import { computed, ref } from '@vue/composition-api';
import SmsSplitter from 'split-sms';

export function useSms() {
  const smsMessagesCount = ref(1);
  const smsMessagesLimit = 1;
  const smsCharactersCount = ref(0);
  const smsCharactersEncoding = ref('');
  const charactersBeforeCounterShown = 1;
  const singleMessageLength = {
    GSM: 160,
    Unicode: 70,
  };
  const multiMessageLength = {
    GSM: 153,
    Unicode: 67,
  };

  function calculateMessage(val) {
    const { characterSet, length, parts } = SmsSplitter.split(val);

    smsCharactersEncoding.value = characterSet;
    smsCharactersCount.value = length;
    smsMessagesCount.value = parts.length;
  }

  const smsCharactersLimit = computed(() => {
    return multiMessageLength[smsCharactersEncoding.value] * smsMessagesLimit;
  });

  const smsLimitExceeded = computed(() => {
    return smsCharactersCount.value > smsCharactersLimit.value;
  });

  return {
    calculateMessage,
    isSmsValid: computed(() => {
      return !smsLimitExceeded;
    }),
    smsLimitExceeded,
    smsCharactersLimit,
    smsCharactersCount,
    smsCounterShown: computed(() => {
      return smsCharactersCount.value
        > singleMessageLength[smsCharactersEncoding.value] - charactersBeforeCounterShown;
    }),
  };
}
